module.exports = __webpack_public_path__ + "img/workspace-onboarding/custom-branding-850d78944aa59a19f844007ea0479277.png";